if (!customElements.get('mw-load-more')) {
  customElements.define('mw-load-more', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.container = this.closest('#ProductGridContainer');
      this.grid = this.container?.querySelector('ul.product-grid');
      this.button = this.querySelector('button');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error-message]');
      if (!this.grid || !this.button || !this.next) return;
      this.label = this.button.textContent.trim();
      this.page = Number(this.dataset.page);
      this.shown = this.grid.children.length;
      this.querySelector('[data-enhanced]').hidden = false;
      this.querySelector('[data-fallback]').hidden = true;
      this.updateStatus();
      this.button.addEventListener('click', (event) => this.load(event));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateStatus() {
      this.status.textContent = this.dataset.count.replace('[shown]', this.shown).replace('[total]', this.dataset.total);
      if (!this.next.getAttribute('href')) {
        this.button.hidden = true;
        if (this.shown === Number(this.dataset.total)) this.status.textContent += ' — ' + this.dataset.complete;
      }
    }

    async load(event) {
      if (this.busy || this.container.querySelector('.collection.loading')) return;
      const href = this.next.getAttribute('href');
      if (!href) return;
      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('section_id', this.dataset.section);
      const originalLocation = window.location.href;
      const keyboard = event.detail === 0;
      this.busy = true;
      this.controller = new AbortController();
      this.button.disabled = true;
      this.button.textContent = this.dataset.loading;
      this.error.hidden = true;
      this.next.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Failed to load products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = doc.querySelector('#ProductGridContainer ul.product-grid');
        const incomingControl = doc.querySelector('mw-load-more');
        const incomingPage = Number(incomingControl?.dataset.page || this.page + 1);
        if (!incomingGrid || !incomingGrid.children.length || incomingPage !== this.page + 1) throw new Error('Invalid product page');
        if (!this.isConnected || window.location.href !== originalLocation || this.container.querySelector('.collection.loading')) return;
        const items = Array.from(incomingGrid.children);
        items.forEach((item) => {
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach((node) => node.classList.add('scroll-trigger--cancel'));
        });
        this.grid.append(...items);
        this.shown += items.length;
        this.page = incomingPage;
        this.next.setAttribute('href', incomingControl?.querySelector('[data-next]')?.getAttribute('href') || '');
        this.updateStatus();
        if (keyboard) {
          const target = items[0].querySelector('a[href], button');
          target?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.error.textContent = this.dataset.error;
          this.error.hidden = false;
          this.next.hidden = false;
          this.status.textContent = this.dataset.error;
        }
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = this.label;
        this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
